import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    itemTitle: {
        height: '24px',
        width: '40px',
        paddingTop: '.75rem'
    },
    tabBar: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        flexBasis: 'auto',
        paddingTop: '2rem',
        borderBottom: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter ||
        '#CFCFCF'}`
    },
    tabContent: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        padding: '0',
        flexBasis: 'auto',
        flexGrow: 1
    },
    tabPanel: { height: '100%' },
    headerStats: {
        paddingTop: '0.75rem',
        paddingRight: '5rem',
        maxWidth: '550px'
    },
    indicator: {
        backgroundColor: theme?.app?.applicationColors.enumColors.greyDark ||
            '#333333'
    },
    topContent: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        paddingLeft: '1.5rem',
        paddingTop: '2.8rem',
        paddingRight: '.5rem',
        paddingBottom: '1rem',
        flexBasis: 'auto'
    },
    backArrow: { width: '50px' },
    infoContainer: {
        width: '700px',
        maxWidth: '700px'
    },
    walletInfoTop: {
        borderBottom: `2px solid ${theme?.app?.applicationColors.enumColors.greyLighter ||
        '#cfcfcf'}`,
        paddingBottom: '1rem'
    },
    walletInfoBottom: { paddingTop: '1.3rem' },
    walletInfoTopLongNameContainer: {
        placeItems: 'flex-start',
        paddingRight: '8px',
        whiteSpace: 'normal' as const
    },
    walletInfoTopLongName: {
        color: theme?.app?.applicationColors.enumColors.greyDark ||
            '#333333',
        fontSize: '18px',
        lineHeight: '22px',
        wordBreak: 'break-word' as const
    },
    walletInfoTopShortNameContainer: {
        placeItems: 'center',
        borderLeft: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter ||
        '#cfcfcf'}`,
        paddingLeft: '5px',
        paddingRight: '5px'
    },
    walletInfoTopShortName: {
        color: theme?.app?.applicationColors.enumColors.greyDark ||
            '#333333',
        fontSize: '18px'
    },
    walletInfoTopAccountContainer: {
        placeItems: 'flex-end',
        borderLeft: '1px solid #ccc',
        paddingLeft: '8px'
    },
    walletInfoTopAccount: {
        color: theme?.app?.applicationColors.enumColors.greyDark ||
            '#333333',
        fontSize: '18px'
    },
    favoriteContainer: {
        height: '100%',
        padding: '.25rem'
    },
    favoriteIcon: {
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter ||
        '#cfcfcf'}`,
        borderRadius: '3px',
        padding: '.2rem',
        cursor: 'pointer' as const
    },
    walletInfoBottomBalance: {
        placeItems: 'flex-end',
        color: theme?.app?.applicationColors.enumColors.greyDark ||
            '#333333'
    },
    walletInfoBottomBalanceContainer: { placeItems: 'flex-start' },
    walletInfoBottomBalanceNumber: {
        color: theme?.app?.applicationColors.enumColors.greyDark ||
            '#333333',
        fontSize: '44px',
        lineHeight: '30px'
    },
    walletInfoBottomBalanceLabel: {
        color: theme?.app?.applicationColors.enumColors.grey ||
            '#888888',
        fontSize: '14px',
        paddingTop: '10px'
    },
    walletInfoBottomDetailsContainer: { placeItems: 'flex-end' },
    walletInfoBottomDetails: {
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        fontSize: '14px',
        fontWeight: 'bold' as const
    },
    showWalletAddressContainer: {
        flexBasis: 'auto' as const,
        width: 'auto' as const,
        height: 'fit-content' as const,
        marginLeft: 'auto' as const,
        cursor: 'pointer' as const
    },
    showWalletAddressIcon: { marginRight: '.5rem' },
    walletAddressWarning: {
        fontSize: '.8rem',
        color: theme?.app?.applicationColors.failureDark ||
            '#AD3D4B',
        textAlign: 'right' as const
    },
    actionButtonContainer: {
        width: '100%',
        paddingTop: '2.5rem'
    },
    actionButton: { marginLeft: '15px' },
    statusIcon: {
        marginRight: '.75rem',
        '&:last-child': { marginRight: 0 },
        textWrap: 'nowrap'
    },
    networkStatus: {
        color: '#375073',
        fontWeight: 'bold' as const,
        marginTop: '0.5em',
        borderRadius: '0.1rem',
        paddingLeft: '0.25rem',
        paddingRight: '0.25rem',
        border: 'none',
        background: 'rgba(0,102,179,0.1)'
    },
    walletTotalBalanceTile: {
        overflowY: 'auto' as const,
        paddingTop: '2.2rem',
        marginBottom: '-1rem'
    }
});